import DataTable from "../../../ShearCompo/DataTable/DataTable";
import Summary from "../../../ShearCompo/Summary/Summary";
import { Icon } from "@material-ui/core";
import { useState } from "react";
import './style/ManageUser.scss';
import { ManageUserAddUserFrom, ManageUserEditDetailsFrom } from "../../../AllForms/AdminFrom/ManageUserFrom";
import ModalLayout from "../../../ShearCompo/ModalLayout/ModalLayout";
import { Form } from "react-bootstrap";

const ManageUser = () => {

    const userFakeData = [
        {
            id: '#546651',
            name: 'Shahed Ador',
            loginID: 'Ador121415',
            email: 'ador@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546652',
            name: 'Abu Hasan',
            loginID: 'sakib123',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546653',
            name: 'Saifur Sakib',
            loginID: 'sakib123',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546654',
            name: 'Saifur Sakib',
            loginID: 'sakib123',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546655',
            name: 'Saifur Sakib',
            loginID: 'sakib123',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546656',
            name: 'Saifur Sakib',
            loginID: 'sakib123',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546657',
            name: 'Amimul Rahi',
            loginID: 'rahi808',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2  MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
        {
            id: '#546658',
            name: 'Shahed Ador',
            loginID: 'ador555',
            email: 'sakib@shopkpr.com',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details',
            action: [<Icon key="edit" className="mr-2 MainDarkGreen" aria-hidden="true">edit</Icon>, 'Edit', <Icon key="delete" className="trash-alt mx-2 LIGHT_RED" aria-hidden="true">delete</Icon>, 'Delete',],
        },
    ]
    const userTableHeading = ['User ID', 'Name', 'Login ID', 'Email', 'Creation Date', 'User Details', 'Action'];
    const AdminSummaryData = [
        {
            name: "Total Users",
            price: "541 Users",
            img: 'https://i.ibb.co/kgRPWkD/Total-users.png'
        },
        {
            name: "This Year",
            price: "541 Users",
            img: 'https://i.ibb.co/bgJpSVj/This-Year.png'
        },
        {
            name: "This Month",
            price: "41 Users",
            img: 'https://i.ibb.co/5sf3jNQ/This-Months.png'
        },
        {
            name: "This Week",
            price: "5 Users",
            img: 'https://i.ibb.co/HgjVJbz/This-Week.png'
        },
    ];
    const [lgShow, setLgShow] = useState(false);
    const [editDetailsF, setEditDetailsF] = useState(false);
    const [singleUserData, setSingleUserData] = useState({});

    const [fromEdit, setFromEdit] = useState();

    const handleClose = () => {
        setLgShow(false);
        setEditDetailsF(false);
    };
    let handleShow = () => setLgShow(true);

    const handleDetails = (e) => {
        setEditDetailsF(true);
        const getUserById = userFakeData.find(data => data.id === e);
        setSingleUserData(getUserById);
        setFromEdit(false);

        // setSingleUserData
    }
    const handleEdit = (e) => {
        setEditDetailsF(true);
        const getUserById = userFakeData.find(data => data.id === e);
        setSingleUserData(getUserById);
        setFromEdit(true);
    }
    return (
        <div className="w-100 overflow-hidden">
            <>
                <div className="row pt-4">
                    <Summary summaryArrData={AdminSummaryData} summaryTitle="Users Summary" />
                </div>
                <div className="adminBtn d-flex justify-content-between">
                    <div className="d-flex csvPdfParent">
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download CSV</span>
                        </div> &nbsp;&nbsp;&nbsp;
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download PDF</span>
                        </div>
                    </div>
                    <div className=" singleBtn MAIN_BG_DARK_GREEN text-white mx-0">
                        <div onClick={handleShow} className="d-flex align-items-center">
                            <Icon className="me-3">add</Icon>
                            <span >Add Users</span>
                        </div>
                    </div>
                </div>
                {/* add user modal from */}
                <ModalLayout
                    ModalTitle="Add User"
                    handleClose={handleClose}
                    Show={lgShow}
                    modalBody={<ManageUserAddUserFrom />}
                />
            </>
            {/* Manage User Data Table */}
            <DataTable
                tableInputFrom={
                    <Form className="col-lg-5 p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="form-bd shadow-sm rounded">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search manage user" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={userTableHeading} tableBodyData={
                    userFakeData?.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <th scope="row">{tableData.id}</th>
                            <td>{tableData.name}</td>
                            <td>{tableData.loginID}</td>
                            <td>{tableData.email}</td>
                            <td> {tableData.creationDate} </td>
                            <td className="cursorPointer" onClick={() => { handleDetails(tableData.id) }}>{tableData.userDetails}</td>
                            <td className="d-flex justify-content-center align-items-center">
                                <span className="cursorPointer MainDarkGreen" onClick={() => handleEdit(tableData.id)}>
                                    <i className="fas fa-pencil-alt"></i>&nbsp;Edit
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                <span className="cursorPointer LIGHT_RED" >
                                    <i className="far fa-trash-alt"></i>&nbsp;Delete
                                </span>
                            </td>
                        </tr>
                    )
                } />

            <ModalLayout
                ModalTitle={`${'User Id-' + singleUserData.id}`}
                Show={editDetailsF}
                handleClose={handleClose}
                modalBody={
                    // user Edit From 
                    <ManageUserEditDetailsFrom
                        userDetails={singleUserData}
                        which={fromEdit && fromEdit} />
                }
            />

        </div >
    );
};

export default ManageUser;